import { jsx } from 'react/jsx-runtime';
import { createSVG } from '../../utils/createSVG/createSVG/index.js';

const IconShareFilled = createSVG({
    children: (jsx("path", { d: "M3.531 19.789c.936-.968 2.138-1.836 3.29-2.523q1.184-.72 2.578-1.208c.426-.112 1.056-.426 1.52-.255.728.268.618 1.095.618 1.715q0 1.464 1.254 2.092 1.254.627 2.322-.326l6.097-5.797q.79-.698.79-1.766 0-1.093-.79-1.79l-6.096-5.946q-1.067-.953-2.322-.326-1.255.628-1.255 2.091c0 .651.244 1.749-.256 2.276-.341.417-1.349 1.012-1.813 1.247q-1.695.86-3.275 2.3-1.578 1.419-2.833 3.486c-.82 1.378-.905 2.26-1.246 4.102-.083.451-.306 1.175.256 1.395.565.177.862-.389 1.161-.767" })),
});

export { IconShareFilled };
